/**
 * Shared full-screen photo viewer (snippets/photo-viewer.liquid, a native
 * <dialog> included once in layout/theme.liquid). Any image on the page can
 * opt in: wrap it in `<button type="button" data-photo-viewer-trigger
 * data-photo-viewer-group="<name>" data-photo-viewer-src="<full-size url>"
 * data-photo-viewer-alt="...">`. All triggers sharing the same `group` value
 * become one set for prev/next paging (e.g. every review's photos share
 * "review-<id>"; every UGC tile shares "ugc"). `.showModal()` gives Escape-
 * to-close and basic focus containment natively; this only adds the
 * prev/next/count wiring on top.
 */
function initPhotoViewer() {
  const dialog = document.querySelector('[data-photo-viewer]');
  if (!dialog) return;

  const image = dialog.querySelector('[data-photo-viewer-image]');
  const count = dialog.querySelector('[data-photo-viewer-count]');
  let group = [];
  let index = 0;

  function show(newIndex) {
    if (!group.length) return;
    index = (newIndex + group.length) % group.length;
    const trigger = group[index];
    image.src = trigger.dataset.photoViewerSrc;
    image.alt = trigger.dataset.photoViewerAlt || '';
    if (count) count.textContent = `${index + 1} / ${group.length}`;
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-photo-viewer-trigger]');
    if (!trigger) return;

    const groupName = trigger.dataset.photoViewerGroup || 'default';
    group = Array.from(document.querySelectorAll(`[data-photo-viewer-trigger][data-photo-viewer-group="${CSS.escape(groupName)}"]`));
    show(group.indexOf(trigger));
    dialog.showModal();
  });

  dialog.querySelector('[data-photo-viewer-close]')?.addEventListener('click', () => dialog.close());
  dialog.querySelector('[data-photo-viewer-prev]')?.addEventListener('click', () => show(index - 1));
  dialog.querySelector('[data-photo-viewer-next]')?.addEventListener('click', () => show(index + 1));

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });

  dialog.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft') show(index - 1);
    if (event.key === 'ArrowRight') show(index + 1);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPhotoViewer);
} else {
  initPhotoViewer();
}
